if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        if (!this.elements.viewer) return;

        this.mql = window.matchMedia('(min-width: 750px)');
        this.isCloneGallery = Boolean(this.closest('.product-main-clone'));
        this.desktopLayoutIsThumbnail = this.dataset.desktopLayout?.includes('thumbnail');
        this.cloneDesktopNav = this.elements.viewer.querySelector('[data-clone-gallery-nav]');
        this.cloneDesktopNavButtons = {
          prev: this.cloneDesktopNav?.querySelector('[data-clone-nav="prev"]'),
          next: this.cloneDesktopNav?.querySelector('[data-clone-nav="next"]'),
        };

        this.handleCloneDesktopNavClick = this.handleCloneDesktopNavClick.bind(this);
        this.handleViewportChange = this.handleViewportChange.bind(this);
        this.lockedMediaHeight = null;

        if (
          this.isCloneGallery &&
          this.desktopLayoutIsThumbnail &&
          this.cloneDesktopNavButtons.prev &&
          this.cloneDesktopNavButtons.next
        ) {
          this.cloneDesktopNavButtons.prev.addEventListener('click', this.handleCloneDesktopNavClick);
          this.cloneDesktopNavButtons.next.addEventListener('click', this.handleCloneDesktopNavClick);
        }

        this.mql.addEventListener('change', this.handleViewportChange);
        this.updateDesktopMediaArrows();
        this.updateLockedMediaHeight(true);

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const viewerMediaItems = this.getViewerMediaItems();
        const activeMedia =
          viewerMediaItems.find((item) => item.dataset.mediaId === mediaId) ||
          viewerMediaItems[0];
        if (!activeMedia) {
          return;
        }
        viewerMediaItems.forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        const isDesktopThumbnailClone = this.isCloneGallery && this.desktopLayoutIsThumbnail && this.mql.matches;
        window.setTimeout(() => {
          if (!isDesktopThumbnailClone && (!this.mql.matches || this.elements.thumbnails)) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (isDesktopThumbnailClone) return;
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);
        this.updateDesktopMediaArrows();

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      getMediaItems() {
        return this.getViewerMediaItems();
      }

      getViewerMediaItems() {
        return Array.from(this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]'));
      }

      getActiveMediaIndex(mediaItems) {
        const activeIndex = mediaItems.findIndex((item) => item.classList.contains('is-active'));
        return activeIndex >= 0 ? activeIndex : 0;
      }

      handleCloneDesktopNavClick(event) {
        if (!this.isCloneGallery || !this.desktopLayoutIsThumbnail || !this.mql.matches) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const mediaItems = this.getMediaItems();
        if (mediaItems.length < 2) return;

        const activeIndex = this.getActiveMediaIndex(mediaItems);
        const direction = event.currentTarget.dataset.cloneNav === 'next' ? 1 : -1;
        const targetIndex = activeIndex + direction;

        if (targetIndex < 0 || targetIndex >= mediaItems.length) return;

        this.setActiveMedia(mediaItems[targetIndex].dataset.mediaId, false);
      }

      updateDesktopMediaArrows() {
        if (
          !this.isCloneGallery ||
          !this.desktopLayoutIsThumbnail ||
          !this.cloneDesktopNavButtons.prev ||
          !this.cloneDesktopNavButtons.next
        )
          return;

        const mediaItems = this.getMediaItems();
        const hasMultipleMedia = mediaItems.length > 1;
        this.classList.toggle('media-gallery--no-desktop-arrows', !hasMultipleMedia);

        if (!hasMultipleMedia) return;
        if (!this.mql.matches) {
          this.cloneDesktopNavButtons.prev.removeAttribute('disabled');
          this.cloneDesktopNavButtons.next.removeAttribute('disabled');
          return;
        }

        const activeIndex = this.getActiveMediaIndex(mediaItems);
        if (activeIndex <= 0) {
          this.cloneDesktopNavButtons.prev.setAttribute('disabled', 'disabled');
        } else {
          this.cloneDesktopNavButtons.prev.removeAttribute('disabled');
        }

        if (activeIndex >= mediaItems.length - 1) {
          this.cloneDesktopNavButtons.next.setAttribute('disabled', 'disabled');
        } else {
          this.cloneDesktopNavButtons.next.removeAttribute('disabled');
        }
      }

      updateLockedMediaHeight(force = false) {
        if (!this.isCloneGallery || !this.desktopLayoutIsThumbnail || !this.mql.matches) return;
        if (!force && this.lockedMediaHeight) return;

        const mediaItems = this.getMediaItems();
        if (!mediaItems.length) return;

        const sampleContainer =
          mediaItems[0].querySelector('.product-media-container.media-type-image') ||
          mediaItems[0].querySelector('.product-media-container');
        if (!sampleContainer) return;

        const sampleWidth = Math.round(sampleContainer.getBoundingClientRect().width);
        const computedStyles = getComputedStyle(sampleContainer);
        const previewRatio = parseFloat(computedStyles.getPropertyValue('--preview-ratio'));
        const mediaRatio = parseFloat(computedStyles.getPropertyValue('--ratio'));
        const ratio = Number.isFinite(previewRatio) && previewRatio > 0 ? previewRatio : mediaRatio;

        let targetHeight = 0;
        if (sampleWidth > 0 && Number.isFinite(ratio) && ratio > 0) {
          targetHeight = Math.round(sampleWidth / ratio);
        } else {
          targetHeight = Math.round(sampleContainer.getBoundingClientRect().height);
        }

        if (targetHeight > 0) {
          this.lockedMediaHeight = targetHeight;
          this.style.setProperty('--product-main-media-height', `${targetHeight}px`);
        } else {
          window.requestAnimationFrame(() => this.updateLockedMediaHeight(force));
        }
      }

      handleViewportChange() {
        this.lockedMediaHeight = null;
        this.updateDesktopMediaArrows();
        this.updateLockedMediaHeight(true);
      }
    }
  );
}
